module.exports = __webpack_public_path__ + "static/media/perception.2cd72afe.jpg";